import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';

export const MODULE_NAME = 'CLOSED_RETURNS_CONTROLLER';

const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);

function namespaced(name) {
  return MODULE_NAME + '.' + name;
};

const LOAD_CLOSED_RETURNS = namespaced('LOAD_CLOSED_RETURNS');
const LOAD_CLOSED_RETURNS_OK = namespaced('LOAD_CLOSED_RETURNS_OK');
const LOAD_CLOSED_RETURNS_FAIL = namespaced('LOAD_CLOSED_RETURNS_FAIL');
const REOPEN_RETURN = namespaced('REOPEN_RETURN');
const REOPEN_RETURN_OK = namespaced('REOPEN_RETURN_OK');
const REOPEN_RETURN_FAIL = namespaced('REOPEN_RETURN_FAIL');
const LOAD_PREVIEW = namespaced('LOAD_PREVIEW');
const LOAD_PREVIEW_OK = namespaced('LOAD_PREVIEW_OK');
const LOAD_PREVIEW_FAIL = namespaced('LOAD_PREVIEW_FAIL');
const UNLOAD = namespaced('UNLOAD');

export const ACTION_TYPES = {
  LOAD_CLOSED_RETURNS,
  LOAD_CLOSED_RETURNS_OK,
  LOAD_CLOSED_RETURNS_FAIL,
  REOPEN_RETURN,
  REOPEN_RETURN_OK,
  REOPEN_RETURN_FAIL,
  LOAD_PREVIEW,
  LOAD_PREVIEW_OK,
  LOAD_PREVIEW_FAIL,
  UNLOAD
};

export const updateSubStateFromAction = (state = {
  data: undefined, loading: false, error: null,}, action) => {
  log.debug('updateSubStateFromAction: ', action, state);
  const getNewState = (action, state) => {
    switch (action.type) {
      case LOAD_CLOSED_RETURNS:
        return Object.assign({}, state, {loading: true });
      case LOAD_CLOSED_RETURNS_OK:
        return Object.assign({}, state, {loading: false, data: action.response });
      case LOAD_CLOSED_RETURNS_FAIL:
        return Object.assign({}, state, {loading: false });
      case REOPEN_RETURN:
        return Object.assign({}, state, {loading: true });
      case REOPEN_RETURN_OK:
        return Object.assign({}, state, {loading: false });
      case REOPEN_RETURN_FAIL:
        return Object.assign({}, state, {loading: false });
      case LOAD_PREVIEW:
        return Object.assign({}, state, {loading: true, previewData: undefined});
      case LOAD_PREVIEW_OK:
        return Object.assign({}, state, {loading: false, previewData: action.response });
      case LOAD_PREVIEW_FAIL:
        return Object.assign({}, state, {loading: false, previewData: undefined });
      case UNLOAD:
        return  Object.assign({}, state, {previewData: undefined, data: undefined});
      default:
        return state;
    }
  };
  const newState = getNewState(action, state);
  log.debug('updateSubStateFromAction: newState', newState);
  return newState;
};


export const API = {
  doUnload: () => {
    return (dispatch) => {
      dispatch({type: UNLOAD });
    }
  },

  getClosedReturns: (params) => {
    return (dispatch) => {
      dispatch({type: LOAD_CLOSED_RETURNS});
      log.debug('getClosedReturns: params: ', params);
      return CLIENT.getClosedReturns(params)
        .then((response) => {
          log.debug('getClosedReturns: succeeded: ', response);
          dispatch({type: LOAD_CLOSED_RETURNS_OK, response: response});
        })
        .catch((error) => {
          log.debug('getClosedReturns: failed: ', error);
          dispatch({type: LOAD_CLOSED_RETURNS_FAIL, error});
        });
    };
  },

  reopenReturn: (params, callback) => {
    return (dispatch) => {
      dispatch({type: REOPEN_RETURN});
      log.debug('reopenReturn: params: ', params);
      return CLIENT.reopenReturn(params)
        .then((response) => {
          log.debug('reopenReturn: succeeded: ', response);
          dispatch({type: REOPEN_RETURN_OK, response: response});
        })
        .then((params={}) => { callback(params) })
        .catch((error) => {
          //TODO handle error codes which are currently in restClient
          log.debug('reopenReturn: failed: ', error);
          dispatch({type: REOPEN_RETURN_FAIL, error});
        })
    }
  },

  getReturnPreview: (params) => {
    return (dispatch) => {
      dispatch({type: LOAD_PREVIEW});
      log.debug('getReturnPreview: params: ', params);
      return CLIENT.getHistoryReport(params)
        .then((response) => {
          log.debug('getReturnPreview(): succeeded: blob: ', response);
          dispatch({type: LOAD_PREVIEW_OK, response: response});
        })
        .catch((error) => {
          log.debug('getReturnPreview(): failed: ', error);
          dispatch({type: LOAD_PREVIEW_FAIL, error});
        });
    };
  },
};

export default API;